(function() {
	
	var Container = include("PIXI.Container"),
		Texture = include("PIXI.Texture"),
		Sprite = include("PIXI.Sprite"),
		Button = include("springroll.pixi.Button");
	
	var TitlePanel = function()
	{
		Container.call(this);
	};
	
	var p = TitlePanel.prototype = Object.create(Container.prototype);
	
	p.setup = function(makePlayButton)
	{
		// create a new Sprite using the texture
		this.background = new Sprite(Texture.fromImage("title_bg2"));
		this.addChild(this.background);
		
		if(makePlayButton)
		{
			var buttonTextures =
			{
				up: "playButton_up",
				over: "playButton_over",
				down: "playButton_down"
			};
			this.playButton = new Button(buttonTextures);
			this.addChild(this.playButton);
		}
	};
	
	p.teardown = function()
	{
		this.removeChildren();
		this.background.destroy();
		if(this.playButton)
			this.playButton.destroy();
		this.background = this.playButton = null;
	};
	
	namespace('heist').TitlePanel = TitlePanel;
}());